import {
	LockClosed16Filled,
	Heart16Regular,
	Heart16Filled,
} from '@fluentui/react-icons'
import { css, styled } from '@styles/theme'

export const CardCourseStyles = {
	Card: styled('div', {
		display: 'flex',
		flexDirection: 'column',
		padding: '18px 16px',
		gap: '10px',
		width: '100%',
		height: '100%',
		background: '$neutral10',
		borderRadius: 12,
	}),

	Image: styled('div', {
		width: '130px',
		height: '81px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& img': {
			borderRadius: 4,
			width: '100%',
			height: '100%',
		},
	}),

	Info: styled('div', {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		'& h3': {
			fontSize: '$xl',
			fontWeight: '$medium',
			lineHeight: '19px',
			color: '$neutral160',
		},
	}),

	buttonLink: css({
		display: 'flex',
		alignItems: 'center',
		gap: '10px',

		svg: {
			width: '22px',
			height: '22px',
			color: '$blue20',
		},
		cursor: 'pointer',
	}),
	cardImage: css({
		minWidth: 110,
		minHeight: 81,

		'@md': {
			minWidth: 130,
			minHeight: 81,
		},
	}),
	CardContentTitle: css({
		display: 'flex',
		gap: '24px',
		justifyContent: 'space-between',
	}),

	CourseName: styled('h3', {
		fontWeight: '$bold',
		fontSize: '16px',
		fontFamily: 'Roboto',
		lineHeight: '19px',
		marginTop: 5,
		maxWidth: '273px',
		color: '$neutral100',
	}),

	LockStyle: styled(LockClosed16Filled, {
		color: '$blue20',
		width: '72px',
		height: '72px',
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%,-50%)',
	}),

	FavoriteIcon: styled(Heart16Regular, {
		color: '$neutral80',
		width: '24px',
		height: '24px',
		marginTop: 5,
		cursor: 'pointer',
	}),
	FavoriteIconFilled: styled(Heart16Filled, {
		color: '$neutral80',
		width: '24px',
		height: '24px',
		marginTop: 5,
		cursor: 'pointer',
	}),

	LockIcon: styled(LockClosed16Filled, {
		color: '$neutral80',
		width: '24px',
		height: '24px',
		marginTop: 5,
		cursor: 'pointer',
	}),

	Line: styled('div', {
		border: '1px solid',
		borderColor: '$neutral50',
	}),

	AvatarContent: styled('div', {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: '10px',
		'& img': {
			borderRadius: 99,
			width: '20px',
			height: '20px',
		},
	}),

	userAvatar: css({
		width: '20px',
		height: '20px',
		borderRadius: '50%',
		backgroundColor: '$blue20',
		color: 'white',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: '14px',
	}),
}
